import { Breeder } from 'pricing/types';
import { apiGetRequest } from 'utilities/http/api/apiHttp';

export const apiBreeder = {
  getBreeder: (breederId: number) =>
    apiGetRequest<{ breeder: Breeder; errors: { value: string[] } }>(
      `breeder/${breederId}`,
    ),
};
